import React from 'react';
import './Sections.scss';

function Section4() {
  return (
    <section className="sections sections-section4">
      <h2 className="sections-title">Settle in and stay awhile</h2>
      <p className="sections-copy">
        Buying or selling a home comes with various associated transaction costs—mortgage
        origination fees, inspections, appraisals, home staging, closing costs, and so forth.
        “Generally speaking, if buyers live in a home for at least three or four years before
        selling, they should come out fine from a financial standpoint,” says Dr. Yun. “On the other
        hand, the flexibility that comes with being a renter can make more sense for someone who
        expects to move within a two-year time frame.”
      </p>
      <p className="sections-copy">
        In the past couple of years, when home prices rose at red-hot rates of 10% to 15%, Yun says
        many buyers could have sold after a single year and made a profit even accounting for
        transaction costs. But he warns that today’s buyers should not count on such large annual
        price gains necessarily continuing in the future. Still, while home price appreciation has
        eased due to rising mortgage rates in recent months, home prices continue to increase
        overall.
      </p>
      <p className="sections-copy">
        “There is often a positive correlation between the amount of time a buyer owns a home and
        the price appreciation she enjoys,” explains Yun. “Someone who lives in a home for 10 or 15
        years is more likely to build greater wealth than a buyer who hopscotches between homes
        every few years, incurring transaction costs with each purchase and sale.”
      </p>
    </section>
  );
}

export default Section4;
